import { ComparisonOperator, Field, FieldType } from "../../vforms-model";
import { SingleSelectionDropdownComponent } from "./single-selection-dropdown.component";
import { SingleSelectionDropdownEditorComponent } from "./single-selection-dropdown-editor.component";
import { SelectionList } from "../selection-list";
import { ComparisonExpression } from "../../expression-settings/model";

export class SingleSelectionDropdownType extends FieldType {
    static Id = "single-selection-dropdown";

    constructor() {
        super();
        this.id = SingleSelectionDropdownType.Id;
        this.icon = "mat_outline:arrow_drop_down_circle";
        this.previewComponent = SingleSelectionDropdownComponent;
        this.editorComponent = SingleSelectionDropdownEditorComponent;
    }

    createField(): Field {
        return new SelectionList(this);
    }

    supportedComparisonOperators(): ComparisonOperator[] {
        return [...super.supportedComparisonOperators(), ComparisonOperator.Equal, ComparisonOperator.NotEqual];
    }

    evaluate(expression: ComparisonExpression, value: any): boolean {
        switch (expression.operator) {
            case ComparisonOperator.Equal:
                return value === expression.value;
            case ComparisonOperator.NotEqual:
                return value !== expression.value;
        }
        return super.evaluate(expression, value);
    }
}
